import { atom } from 'nanostores'
import { native } from '@forest/native-services'

interface State {
  isOpen: boolean
  trialEndDate: string
}

const initialState: State = {
  isOpen: false,
  trialEndDate: '',
}

export const $reminderDialog = atom<State>(initialState)

let resolvePromise: (() => void) | null = null

export const reminderDialog = {
  open: (trialEndDate: string): Promise<void> => {
    return new Promise((resolve) => {
      resolvePromise = resolve
      $reminderDialog.set({
        isOpen: true,
        trialEndDate,
      })
    })
  },

  onRemind: async () => {
    try {
      await native.permission.requestNotificationPermission()
    } catch {
      // ignore
    }
    reminderDialog.close()
  },

  onDismiss: () => {
    reminderDialog.close()
  },

  close: () => {
    $reminderDialog.set({
      ...$reminderDialog.get(),
      isOpen: false,
    })
    resolvePromise?.()
    resolvePromise = null
  },
}
